import { render, staticRenderFns } from "./partnerShipsEdit.vue?vue&type=template&id=4b5b5906&scoped=true"
import script from "./partnerShipsEdit.vue?vue&type=script&lang=js"
export * from "./partnerShipsEdit.vue?vue&type=script&lang=js"
import style0 from "./partnerShipsEdit.vue?vue&type=style&index=0&id=4b5b5906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b5906",
  null
  
)

export default component.exports